/*
 * @Author: LiuChuanQi
 * @Date: 2022-11-25 17:20:26
 * @LastEditTime: 2022-12-07 18:10:08
 * @LastEditors: LiuChuanQi
 * @Description: 写一个全局的vue实例导出
 * 为何不写进<APP>里，假如验证弹窗需要在渲染前调用，此时APP未渲染出来，里边的组件自然无法调用
 * 在项目加载前就可以直接使用。
 * @FilePath: \speedtest-bigdata-v2\src\components\common\login\login.js
 * 
 */
import Vue from "vue"
import Login from './login.vue'
// 这里可以用Vue.extend()创建子类，没打算注册为组件，就直接`new Vue`
const loginDialog = new Vue(Login)
loginDialog.$mount(document.createElement('div'))
document.body.appendChild(loginDialog.$el)

Vue.prototype.$loginDialog = loginDialog

export default loginDialog

